import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-policies',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss']
})
export class PoliciesComponent implements OnInit {

  constructor(private route: ActivatedRoute) {
  }

  ngOnInit() {
  }
}
